import React, { Component } from "react";
import { connect } from "react-redux";
import { Cache } from "aws-amplify";
import "./App.css";
import { HashRouter as Router, Route, Switch } from "react-router-dom";

import {
  AlertMessage,
  isCompanyAdmin,
  isActive,
  isSuperAdmin,
} from "./common/Utilities";
import { toggleShowAlert } from "./store/actions/commonActions";

import Main from "./components/layout/Main";
import Authenticator from "./components/auth/Authenticator";
import { checkIsUpdated, setUserData } from "./store/actions/auth/authActions";
import Login from "./components/Login";

class App extends Component {
  render() {
    return (
      <div className="App">
        <AlertMessage
          show={this.props.common.showAlert}
          onCloseFunc={() => {
            if (this.props.common.showAlert === true) {
              this.props.toggleShowAlert(false);
            }
          }}
          type={this.props.common.alertType}
          message={this.props.common.alertMessage}
        />
        <Router>
          <Switch>
            <Route exact path="/" component={Authenticator} />

            <Route exact path="/login" component={Login} />

            <Route exact path="/dashboard" component={Main} />

            <Route exact path="/posts" component={Main} />
            <Route exact path="/posts/new" component={Main} />
            <Route exact path="/posts/edit" component={Main} />
            <Route exact path="/posts/view" component={Main} />

            <Route exact path="/terms/edit" component={Main} />
            <Route exact path="/privacy-policy/edit" component={Main} />
            <Route exact path="/faqs/edit" component={Main} />

            <Route exact path="/send-notification" component={Main} />

            <Route exact path="/reports/usage-statistics" component={Main} />

            {/* <Route exact path='/settings/users' component={Main} />
            <Route exact path='/settings/users/edit' component={Main} />
            <Route exact path='/settings/users/disabled' component={Main} /> */}

            <Route exact path="/settings/admins" component={Main} />
            <Route exact path="/settings/admins/new" component={Main} />
            <Route exact path="/settings/admins/edit" component={Main} />
            <Route exact path="/settings/admins/disabled" component={Main} />

            <Route exact path="/settings/roles-permissions" component={Main} />
            <Route
              exact
              path="/settings/roles-permissions/new"
              component={Main}
            />
            <Route
              exact
              path="/settings/roles-permissions/edit"
              component={Main}
            />

            <Route exact path="/settings/company" component={Main} />
            <Route exact path="/settings/company/add" component={Main} />

            <Route exact path="/asuite-apps" component={Main} />
            <Route exact path="/asuite-apps/new" component={Main} />
            <Route exact path="/asuite-apps/edit" component={Main} />

            <Route exact path="/splash-screens" component={Main} />
            <Route exact path="/splash-screens/new" component={Main} />
            <Route exact path="/splash-screens/edit" component={Main} />

            <Route exact path="/mobile-app-banner" component={Main} />
            <Route exact path="/mobile-app-banner/new" component={Main} />
            <Route exact path="/mobile-app-banner/edit" component={Main} />

            <Route exact path="/app-versions" component={Main} />
            <Route exact path="/app-versions/new" component={Main} />
          </Switch>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
});

const mapStateToDispatch = (dispatch) => {
  return {
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(App);
